<ckeditor
  class="mat-typography"
  tagName="textarea"
  [config]="_editorConfig"
  [disabled]="applying"
  [editor]="Editor"
  [(ngModel)]="_internalValue"
  (ngModelChange)="hideEditorControls ? changeValue('APPLY') : null"
  (ready)="_onReady($event)"
></ckeditor>

<mtna-inline-editor-controls
  *ngIf="!hideEditorControls"
  [hidden]="value === _internalValue || readonly"
  [disableApply]="readonly"
  [applying]="applying"
  (action)="changeValue($event)"
></mtna-inline-editor-controls>
